import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import AdvanceForm from './AdvanceForm'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

@withGraphQL(gql`
  query getDynamicSellNote($dynamicId: ID) {
    getDynamicSellNote(dynamicId: $dynamicId) {
      _id
      preparationId
      userId
      total
      transferenciaAdicional
      tcAdicional
      ocAdicional
      chequeAdicional
      efectivoAdicional
      transferencia
      tc
      oc
      cheque
      efectivo
      tarifa
      valorUf
      valorKit
      dctosEspeciales
      subTotal
      mesAnticipado
      ivaAnticipado
      elementosAdicionales
      totalMensualidad
      valorAdicionales
      ivaNeto
      totalNeto
      productArray {
        codigo
        description
        price
        amount
        total
      }
    }
  }
`)
export default class SSSellNoteAdvance extends React.Component {
  static propTypes = {
    params: PropTypes.object,
    getDynamicSellNote: PropTypes.object
  }

  state = {}

  componentDidMount() {
    const {
      total,
      transferenciaAdicional,
      tcAdicional,
      ocAdicional,
      chequeAdicional,
      efectivoAdicional,
      transferencia,
      tc,
      oc,
      cheque,
      efectivo,
      tarifa,
      valorUf,
      valorKit,
      dctosEspeciales,
      subTotal,
      mesAnticipado,
      ivaAnticipado,
      elementosAdicionales,
      totalMensualidad,
      valorAdicionales,
      ivaNeto,
      totalNeto,
      productArray
    } = this.props.getDynamicSellNote
    const formData = {
      total,
      transferenciaAdicional,
      tcAdicional,
      ocAdicional,
      chequeAdicional,
      efectivoAdicional,
      transferencia,
      tc,
      oc,
      cheque,
      efectivo,
      tarifa,
      valorUf,
      valorKit,
      dctosEspeciales,
      subTotal,
      mesAnticipado,
      ivaAnticipado,
      elementosAdicionales,
      totalMensualidad,
      valorAdicionales,
      ivaNeto,
      totalNeto,
      productArray
    }
    this.setState({
      formData
    })
  }

  render() {
    const { _id, preparationId } = this.props.getDynamicSellNote
    if (!this.state.formData) return null
    console.log(this.state.formData)
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">Formulario de nota de venta dinámico</div>
          <AdvanceForm
            sellNoteId={_id}
            preparationId={preparationId}
            formData={this.state.formData}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/index.js